import React from 'react';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import App from './app';
import { UserContextProvider } from './Services/Restore/context/user-context';
import enMessages from './Services/Restore/config/translation/locales/en_US.json';
import './app.css';
import { CallProvider } from './Services/Restore/context/CallContext';
import { TwilioProvider } from './Services/Restore/context/TwilioContext';
import TwilioInitializer from './Services/Restore/components/TwilioInitializer';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

// Enhanced error handling for React rendering
const root = ReactDOM.createRoot(document.getElementById('root'));

try {
  root.render(
    <React.StrictMode>
      <IntlProvider messages={enMessages} locale="en">
        <UserContextProvider>
          <TwilioProvider>
            <CallProvider>
              <TwilioInitializer />
              <App />
            </CallProvider>
          </TwilioProvider>
        </UserContextProvider>
      </IntlProvider>
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to render app:', error);
  // Show error message to user
  document.getElementById('root').innerHTML = `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; font-family: Arial, sans-serif;">
      <h1 style="color: #f44336;">Application Error</h1>
      <p>Failed to load the application. Please refresh the page.</p>
      <button onclick="window.location.reload(true)" style="padding: 10px 20px; background: #1976d2; color: white; border: none; border-radius: 4px; cursor: pointer; margin-top: 20px;">
        Refresh Page
      </button>
    </div>
  `;
}
